import { OrderStatus } from "./Order";

export const isValidResponse200 = (response) => response && response.result && response.result.Code === 200;

export const canOfferUseProcessDate = ({ order, services }) => {
  if (!order || !services.account) return false;

  const isFromOffer = order.offer && order.offer.OfferId != "0";
  const isOrderNew = !order.OrderId || order.OrderId === "0";
  const isParked = order.OrderStatus === OrderStatus.PARKED;

  const servicesAvailable =
    services.account.fetchGetNextValidWithParameters &&
    services.account.fetchRecalculatePriceWithProcessDate;

  return isFromOffer && servicesAvailable && (isOrderNew || isParked);
};